const strings = {
  en: {
    brandDesc:
      'Sales Assistant Performance Optimization Tool. AI-powered conversation intelligence for sales teams.',
    privacy: 'Privacy',
    terms: 'Terms',
    deleteAccount: 'Delete Account',
    columns: [
      {
        title: 'Product',
        links: [
          { label: 'Features', page: 'product' },
          { label: 'Pricing', page: 'pricing' },
          { label: 'Blog', url: 'https://blog.sapot.ai/public/articles' },
        ],
      },
      {
        title: 'Solutions',
        links: [
          { label: 'Retail', page: 'product' },
          { label: 'Property', page: 'product' },
          { label: 'F&B', page: 'product' },
          { label: 'Enterprise', page: 'pricing' },
        ],
      },
      {
        title: 'Resources',
        links: [
          { label: 'Blog', url: 'https://blog.sapot.ai/public/articles' },
          { label: 'FAQ', page: 'pricing' },
          { label: 'Support', page: 'contact' },
          { label: 'Download App', page: 'download' },
        ],
      },
      {
        title: 'Company',
        links: [
          { label: 'About', page: 'about' },
          { label: 'Contact', page: 'contact' },
          { label: 'Privacy', page: 'privacyPolicy' },
          { label: 'Delete Account', page: 'delete-account' },
        ],
      },
    ],
  },
  zh: {
    brandDesc:
      'SAPOT AI——销售助理绩效优化平台。为销售团队提供 AI 驱动的对话智能分析。',
    privacy: '隐私政策',
    terms: '服务条款',
    deleteAccount: '删除账号',
    columns: [
      {
        title: '产品',
        links: [
          { label: '功能', page: 'product' },
          { label: '价格', page: 'pricing' },
          { label: '博客', url: 'https://blog.sapot.ai/public/articles' },
        ],
      },
      {
        title: '解决方案',
        links: [
          { label: '零售业', page: 'product' },
          { label: '房地产', page: 'product' },
          { label: '餐饮业', page: 'product' },
          { label: '企业版', page: 'pricing' },
        ],
      },
      {
        title: '资源中心',
        links: [
          { label: '博客', url: 'https://blog.sapot.ai/public/articles' },
          { label: '常见问题', page: 'pricing' },
          { label: '客户支持', page: 'contact' },
          { label: '下载应用', page: 'download' },
        ],
      },
      {
        title: '公司',
        links: [
          { label: '关于我们', page: 'about' },
          { label: '联系我们', page: 'contact' },
          { label: '隐私政策', page: 'privacyPolicy' },
          { label: '删除账号', page: 'delete-account' },
        ],
      },
    ],
  },
};

export default strings;
